import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import cx from 'classnames';
import { IconButton, useParcaContext } from '@parca/components';
import { CloseIcon } from '@parca/icons';
import ViewSelector from './ViewSelector';
export const VisualizationPanel = React.memo(function VisualizationPanel({ dashboardItem, index, isMultiPanelView, handleClosePanel, navigateTo, dragHandleProps, getDashboardItemByType, }) {
    const [actionButtons, setActionButtons] = useState(_jsx(_Fragment, {}));
    const { flamegraphHint } = useParcaContext();
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex w-full items-start justify-end gap-2 pb-2", children: [_jsxs("div", { className: "flex w-full items-start justify-between flex-col-reverse md:flex-row", children: [_jsxs("div", { className: "flex items-start", children: [_jsx("div", { className: cx(isMultiPanelView ? '' : 'hidden', 'flex items-center'), ...dragHandleProps, children: _jsx(Icon, { className: "text-xl", icon: "material-symbols:drag-indicator" }) }), _jsx("div", { children: actionButtons })] }), _jsxs("div", { className: "flex flex-col items-end gap-4", children: [_jsx(ViewSelector, { defaultValue: dashboardItem, navigateTo: navigateTo, position: index }), _jsx("div", { className: "px-2", children: dashboardItem === 'icicle' && flamegraphHint != null ? flamegraphHint : null })] })] }), isMultiPanelView && (_jsx(IconButton, { className: "py-0", onClick: () => handleClosePanel(dashboardItem), icon: _jsx(CloseIcon, {}) }))] }), getDashboardItemByType({
                type: dashboardItem,
                isHalfScreen: isMultiPanelView,
                setActionButtons,
            })] }));
});
